import React from 'react';
import styles from './index.module.scss';

const Sport = ({ className }) => (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width='44'
        height='44'
        viewBox='0 0 44 44'
        className={className}
    >
        <g transform='translate(355.414 -522.88)'>
            <path
                d='M5,0H15a5,5,0,0,1,5,5V15a5,5,0,0,1-5,5H5a5,5,0,0,1-5-5V5A5,5,0,0,1,5,0Z'
                transform='translate(-331.414 522.88)'
                className={styles.light}
            />
            <path
                d='M5,0H15a5,5,0,0,1,5,5V15a5,5,0,0,1-5,5H5a5,5,0,0,1-5-5V5A5,5,0,0,1,5,0Z'
                transform='translate(-331.414 546.88)'
                className={styles.light}
            />
            <path
                d='M5,0H15a5,5,0,0,1,5,5V15a5,5,0,0,1-5,5H5a5,5,0,0,1-5-5V5A5,5,0,0,1,5,0Z'
                transform='translate(-355.414 522.88)'
                className={styles.light}
            />
            <path
                d='M5,0H15a5,5,0,0,1,5,5V15a5,5,0,0,1-5,5H5a5,5,0,0,1-5-5V5A5,5,0,0,1,5,0Z'
                transform='translate(-355.414 546.88)'
                className={styles.light}
            />
        </g>
    </svg>
);

export default Sport;
